<template>
  <slot name="header_close" />
  <div class="info-dialog">
    <i :class="['fa', iconClass]" />
    <p class="info">{{ textState }}</p>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

const store = useStore();
const route = useRoute();
const { t: $t } = useI18n();

const translate = {
  existsError: "dialog.add_number.number_exists_error",
  error: "dialog.add_number.error",
  errorSystem: "dialog.add_number.error_system",
  selectedNumberError: "components.tariffs.selected_number_error",
  // NUMBER ACTIVATION ERRORS
  invalidNumberError: "errors.invalid_number_error",
  existsNumberError: "errors.existing_number_error",
  alreadyActivatedError: "errors.already_activated_error",
  // NUMBER STATUS
  numberDisabled: "dialog.number_disabled.info",
  // ACCOUNT STATUS (tiktok)
  accountDisabled: "dialog.account_disabled.info",
  numberActivated: "page.activation_success.mainheader",
  numberActivatedAvans: "page.avans1.success",
};

const icons = {
  numberDisabled: "icon-no-phone",
  accountDisabled: "icon-no-phone",
};

const textState = computed(() => {
  if ("info" in store.state.dialogParams) {
    const translateVariable = {
      number:
        store.state.activation?.anotherNumber || // при активации другого номера
        store.state.dialogParams?.info?.number ||
        store.state.dialogParams?.number ||
        store.getters.getNumber ||
        route.params.number,
    };
    return $t(translate[store.state.dialogParams.info], translateVariable);
  } else {
    return $t("general.error_msg");
  }
});

const iconClass = computed(() => {
  if ("infoIcon" in store.state.dialogParams) {
    // GREEN CHECK ICON IN CIRCLE
    return "fa-check-circle-o";
  } else {
    // CUSTOM ICONS OR RED INFO ICON IN CIRCLE
    return icons?.[store.state.dialogParams.info] || "fa-info-circle";
  }
});
</script>

<style lang="scss">
.info-dialog {
  padding: 45px 26px;
  display: flex;
  align-items: center;
  gap: 24px;
  flex-direction: row;
  box-sizing: border-box;
  border-radius: 7px;
  background-color: white;

  text-align: center;
  font-family: Gilroy;
  font-size: 24px;
  font-weight: 500;
  color: #000000ff;

  .fa {
    background: var(--block-color);
    border-radius: 15px;
    padding: 7px 10px;
  }

  .fa-info-circle {
    //color: var(--text-second-color);
    color: #ff5722;
    font-size: 300%;
  }

  .fa-check-circle-o {
    color: var(--success-color);
    font-size: 300%;
  }

  .fa-exclamation-circle {
    color: var(--danger-second-color);
    font-size: 300%;
  }

  .info {
    width: 100%;
    text-align: left;
  }

  .icon-no-phone {
    color: var(--danger-color);
    font-size: 300%;
  }
}

.preview {
  width: 93px;
  height: 93px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;
  background-color: var(--block-color) ff;

  span {
    font-size: 65px;

    color: #df7070ff;
  }
}
</style>
